<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>支付终端列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
        size="mini"
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="100px"
        autocomplete="on"
      >

        <el-form-item>
          <el-input v-model="searchForm.shop_name" placeholder="请输入客户名称" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item >
          <el-input v-model="searchForm.operator_name" placeholder="请输入业务员" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.dic_id"
            style="width: 180px;"
            placeholder="请选择类别"
          >
            <el-option
              v-for="item in dicList"
              :key="item.id"
              :label="item.name"
              :value="item.id">

            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item>
          <el-button type="success"  @click="searchSubmit()" icon="el-icon-search">搜索</el-button>
          <el-button type="primary"  @click="goAdd()" icon="el-icon-plus">新增终端</el-button>
        </el-form-item>
        <el-form-item>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        stripe
        border
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="所属代理"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.proxy?scope.row.proxy.real_name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属商户"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.posmember?scope.row.posmember.merchant_name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="支付通道"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.source?scope.row.source.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="终端号"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.term_no}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="终端编码"
          width="160"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.term_sn}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="终端地址"
          width="300"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.term_address}}</span>
          </template>
        </el-table-column>


        <!--        <el-table-column-->
        <!--          fixed="right"-->
        <!--          label="操作"-->
        <!--          width="90">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-dropdown  size="mini"  split-button type="text"  trigger="click">-->
        <!--              更多-->
        <!--              <el-dropdown-menu slot="dropdown" trigger="click">-->
        <!--                <el-dropdown-item @click.native="goProformance(scope.row)">查看修改</el-dropdown-item>-->
        <!--              </el-dropdown-menu>-->
        <!--            </el-dropdown>-->

        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="支付通道"  requried>

        </el-form-item>
        <el-form-item label="终端编码" prop="term_sn">
          <el-input v-model="form.term_sn" autocomplete="off" placeholder="请输入终端编码"></el-input>
        </el-form-item>
        <el-form-item label="终端号" prop="term_no">
          <el-input v-model="form.term_no" autocomplete="off" placeholder="请输入终端号"></el-input>
        </el-form-item>
        <el-form-item label="终端地址" prop="term_address">
          <el-input v-model="form.term_address" autocomplete="off" placeholder="请输入终端地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    
    <ePosMember
            :formData="formData"
            :visible="visible1"
            :title="title1"
            :closeForm="closeForm1"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from "axios";     //日期时间转换

  export default {
    name: "posMemberTerminalList",
    components: {
    },
    props: {},
    data() {
      return {

        baseUrl:'/api/',
        isDel:true,
        isEdit:true,
        multipleSelection:[],
        dicList:[],
        // 搜索
        searchForm: {
          name: "",
          operator_name:'',
          shop_name:''
        },
        searchRules: {
          term_address: [
            { required: true, message: "请输入终端地址", trigger: "blur" }
          ],
          term_no: [
            { required: true, message: "请输入终端号", trigger: "blur" }
          ],
          term_sn: [
            { required: true, message: "请输入终端编码", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入保司名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          term_address: '',
          term_no:'',
          term_sn:''
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList()
     // this.departData()
    },
    mounted() {
    },
    filters: {

      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

    },
    methods: {
      goAdd(){
        this.dialogFormVisible=true;
      },
      goExcel(){
        let _this=this;
        let url= _this.baseUrl+'api/cmp.engineering.Contract_read_lz/exportExcel';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };

        axios.post(url, params, { responseType: 'arraybuffer' }).then(response => {
          const fileType = [
            'application/vnd.ms-excel;charset=utf-8', // xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' // xlsx
          ]
          const blob = new Blob([response.data], { type: fileType })
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)
          const contentDisposition = response.headers['content-disposition'] // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
          const result = patt.exec(contentDisposition);
          console.log('result------',result)
          const filename = decodeURI(escape(result[1])) // 处理文件名,解决中文乱码问题
          downloadElement.style.display = 'none'
          downloadElement.href = href
          downloadElement.download = filename // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        });
        // console.log('params------',params)
        // axios({
        //   url:url, // 后端接口URL
        //   method: 'get', // 请求方法，根据后端接口要求
        //   params:params,
        //   responseType: 'blob', // 表示返回的数据类型，这里是二进制文件
        // }).then((response)=>{
        //   console.log('444444response-----',response)
        //   const url = window.URL.createObjectURL(new Blob([response.data],{type:'application/vnd.ms-excel'}));
        //   const link = document.createElement('a');
        //   link.href = url;
        //   link.setAttribute('download', 'export.xlsx'); // 导出文件名
        //   document.body.appendChild(link);
        // }).catch(error => {
        //   console.error('请求出错:', error);
        // });;
      },
      handleSelectionChange(val) {

        this.multipleSelection = val;
        if(this.multipleSelection.length==1){
          this.isEdit=false;
          this.isDel=false;
        }else{
          this.isDel=true;
          this.isEdit=true;
        }
        console.log('selected----',val)
      },
      goProformance(e){
        this.$confirm('您确定审核后生成业绩吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            path:'/costContractForm',
            query:{
              contract_id:e.id
            }
          });
        }).catch(action => {
          // 点击取消:不删除了
          if (action === 'cancel') {
            this.$message({
              type: 'info',
              message: '已取消生成'
            });
            this.pageNum = 1;
            this.DataList()
          }
        });

      },
      goInfo(row){
        this.$router.push({
          path:'/costContractInfo',
          query:{
            id:row.id
          }
        })
      },

      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.posMemberTerminalListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },


      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.pageNum=1;
        this.total=0;
        this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
